import { render, staticRenderFns } from "./brand_collect.vue?vue&type=template&id=2df4ba50&scoped=true"
import script from "./brand_collect.vue?vue&type=script&lang=js"
export * from "./brand_collect.vue?vue&type=script&lang=js"
import style0 from "./brand_collect.vue?vue&type=style&index=0&id=2df4ba50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4ba50",
  null
  
)

export default component.exports